import {ICommonAttributes, IElement} from 'routes/private/Editor/types';

export const lockUnlockResolver = ( element: IElement, value?: boolean ) => {
  if (element.type!=="Artboards") (element.attributes as ICommonAttributes).locked = value;
  return element;
}